import { render, staticRenderFns } from "./Terminbestaetigung.vue?vue&type=template&id=32a6d3c6"
import script from "./Terminbestaetigung.vue?vue&type=script&lang=js"
export * from "./Terminbestaetigung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports